














import Vue from 'vue';
import A11yHelper from '@/helpers/A11yHelper';
import { IDesktopDropdownSubEntryComponent, IMenuItem } from '@/common/interfaces/header.interface';
import AppHelper from '../../../helpers/AppHelper';

export default Vue.extend({
  name: `DesktopDropdownSubEntry`,
  data(): IDesktopDropdownSubEntryComponent {
    return {
      AppHelper,
    };
  },
  props: {
    items: {
      required: true,
      type: Array as () => IMenuItem[],
    },
  },
  methods: {
    focusOut(e: FocusEvent | null, elementIndex: number): void {
      if(elementIndex + 1 === this.items.length) {
        this.$emit(`close:dropdown`, !A11yHelper.isFocusWithinCurrentGroup(e));
      }
    },
  },
});
